import {
  GeneralInfoObject,
  PagesObject,
  PlatformObject,
} from '@wix/document-services-types';
import { Shell, SlotKey } from 'repluggable';
import { A11yWizardEditorAdapter } from '@wix/a11y-adapters/editor';

// This workaround is in order to get the api key we created in santa-editor without consume the package and create dependency loop.
export interface A11yWizardAdapterAPI extends A11yWizardEditorAdapter {
  contributePanel: (shell: Shell, component: any) => void;
  getPanelState?: () => Record<string, any> | undefined;
}

export const A11yAdapterApiKey: SlotKey<A11yWizardAdapterAPI> = {
  name: 'A11yWizardAdapterAPI',
  layer: 'UI',
  public: true,
};

export interface EditorAPI {
  generalInfo: GeneralInfoObject;
  platform: PlatformObject;
  site: {};
  pages: PagesObject;
}

export const EditorAPIKey: SlotKey<EditorAPI> = {
  name: 'EditorAPI',
  public: true,
};

export interface EditorParams {
  esi: string;
}

export const EditorParamsApiKey: SlotKey<EditorParams> = {
  name: 'EditorParamsApi',
  public: true,
};
